import React from 'react';

import type { InstagramPostComponentsProps } from './types';

export function Footer(_props: InstagramPostComponentsProps): React.JSX.Element {
	return <div>Instagram Post Footer</div>;
}
